/* eslint-disable @typescript-eslint/no-explicit-any */
import { DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState, useEffect } from "react";
import {
  queryPostCode,
} from "@/common-components-src/api/address/address.api";
import { isPostCodeAddress, initAddress, isAddress } from "@/utils/addressUtils";
import to from "await-to-js";
import LocationError from "../icons/LocationError.svg";
import AddressArrow from "../icons/AddressArrow.svg";
import UKDialog from "@/common-components-src/components/UKDialog";
import AddressPostCodeList from "@/common-components-src/js/address/addressPostList";
import { PAGE_TYPE } from "@/common-components-src/js/server";

import styles from "./index.module.scss";

interface DataProps {
  pageType?: typeof PAGE_TYPE[keyof typeof PAGE_TYPE];
}

const FloatBottomTips: React.FC<DataProps> = ({ pageType }) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isNotDeliverable, setIsNotDeliverable] = useState(false); //当前postcode是否满足配送范围
  const [postCodeAddress, setPostCodeAddress] = useState<any>();

  useEffect(() => {
    initLocalAddress();
  }, []);

  const initLocalAddress = () => {
    initAddress().then((data) => {
      // 获取缓存postCode
      if (isPostCodeAddress(data)) {
        // 判断postCode是否在配送范围内 isDefaultLocal判断是因为如果默认兜底地址不展示postcode 则不需要展示是否可配送
        getPostCodeDeliverable(!data?.isDefaultLocal ? data?.postCode : "");
        return;
      }
      // 获取缓存postCode
      if (isAddress(data)) {
        // 判断postCode是否在配送范围内 isDefaultLocal判断是因为如果默认兜底地址不展示postcode 则不需要展示是否可配送
        getPostCodeDeliverable(data?.postCode);
        return;
      }
    });
  }

  const getPostCodeDeliverable = async (postCodeValue: string) => {
    if (!postCodeValue) {
      setIsNotDeliverable(false);
      return;
    }
    const [err, result] = await to(
      queryPostCode({ postCode: postCodeValue, checkDeliverableFlag: true }),
    );
    if (result?.code === "200" && result?.data) {
      setPostCodeAddress(result?.data);
      setIsNotDeliverable(result?.data?.isDeliverable === false);
      return;
    }
    setIsNotDeliverable(false);
  };

  const closeHandler = () => {
    setIsOpenDialog(false);
  };

  const addressDialog = () => {
    return (
      <>
        <UKDialog
          open={isOpenDialog}
          onClose={closeHandler}
          showCloseBtn={true}
          sx={{
            "& .MuiDialog-paper": {
              width: "880px", // 设置自定义宽度
              maxWidth: "none", // 取消最大宽度限制
              maxHeight: "534px",
              minHeight: "334px",
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={closeHandler}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <AddressPostCodeList handleAddressClose={closeHandler} isOpenDialog={isOpenDialog} />
          </DialogContent>
        </UKDialog>
      </>
    );
  };

  return (
    <>
      {
        isNotDeliverable && <div className={styles.container}>
          <span><LocationError /></span>
          <span className={styles.text}>{postCodeAddress?.tipsInfo?.showText}</span>
          <span className={styles.right} onClick={() => setIsOpenDialog(true)}>{postCodeAddress?.tipsInfo?.clickText} <AddressArrow /></span>
          {addressDialog()}
        </div>
      }
    </>
  );
};

export default FloatBottomTips;
